/** @jsxImportSource @emotion/react */
import { Switch as MuiSwitch } from '@mui/material';
import { createStyles } from '../../utils';

export interface Props {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

export const Switch = ({ checked, onChange, disabled }: Props) => {
  const styles = useStyles();
  return (
    <div css={styles.main}>
      <MuiSwitch
        checked={checked}
        aria-label={checked ? 'Switch On' : 'Switch Off'}
        disabled={disabled}
        onChange={() => onChange && onChange(!checked)}
      />
    </div>
  );
};

const useStyles = createStyles(({ palette, spacing }) => ({
  main: {
    '& .MuiSwitch-root': {
      width: `calc(${spacing.m} - 3 * (${spacing.xxxs} / 4))`,
      height: `calc(${spacing.xs} + (${spacing.xxxs} / 4))`,
      padding: 0,
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: `translateX(${spacing.xxs})`,
          color: palette.white,
          '& + .MuiSwitch-track': {
            backgroundColor: palette.success.default,
            opacity: 1,
            border: 0,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          color: palette.grey.x100,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.7,
        },
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: `calc(${spacing.xs} - (${spacing.xxxs} / 4))`,
        height: `calc(${spacing.xs} - (${spacing.xxxs} / 4))`,
      },
      '& .MuiSwitch-track': {
        borderRadius: `calc(${spacing.xs} / 2)`,
        backgroundColor: palette.grey.x300,
        opacity: 1,
        transitionDuration: '300ms',
      },
    },
  },
}));
